import { doFetch } from 'common/baseFetch';
import useSWR, { Fetcher } from 'swr';
import { TideResponse } from 'types/tide';
import { tidesFetchPath } from 'utils/urls/tideCharts';

const useFetchTides = (spotId: string, startDate?: string) => {
  const {
    data,
    error,
    isLoading: loading,
  } = useSWR(tidesFetchPath(spotId, startDate), doFetch as Fetcher<TideResponse>, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    errorRetryCount: 0,
  });

  return {
    data,
    loading,
    error,
  };
};

export default useFetchTides;
